import { useGetUser, useSession } from 'src/hooks';
import { useGetComplementaryOfferQuery } from 'src/store/services';

export const useCancelOffers = () => {
  const { appUser } = useSession();
  const { isOpenTier } = useGetUser();

  const userId = appUser?.user_id;
  const shouldSkip = isOpenTier || !userId;

  const { data, isLoading } = useGetComplementaryOfferQuery(
    { user_id: userId ?? '' },
    { skip: shouldSkip },
  );

  return { cancelOffers: data, isCancelOffersLoading: isLoading };
};
